import { SxProps } from '@mui/material';
import MUITextField from '@mui/material/TextField';
import { ChangeEventHandler } from 'react';
import { Controller, Control, FieldValues, FieldErrors } from 'react-hook-form';

export interface TextFieldProps {
  id: string;
  label: string;
  name: string;
  type?: string;
  multiline?: boolean;
  defaultValue?: string | number;
  required?: boolean;
  placeholder?: string;
  control: Control<FieldValues, any>;
  errors?: FieldErrors;
  error?: string;
  sx?: SxProps;
  inputLabelProps?: any;
  inputProps?: any;
  disabled?: boolean;
  hidden?: boolean;
  inputAttributes?: {};
  onChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  autoFocus?: boolean;
}

export const TextField = ({
  id,
  name,
  defaultValue,
  label,
  multiline = false,
  required = false,
  placeholder,
  control,
  errors,
  error,
  sx,
  inputProps,
  inputLabelProps,
  type,
  inputAttributes,
  disabled = false,
  onChange,
  autoFocus = false,
}: TextFieldProps) => {
  return (
    // controller is built in to react-hook-form and it allows your input to be registered with useForms internal state.
    <Controller
      rules={{ required }}
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => {
        return (
          <MUITextField
            {...field}
            // Keep the input controlled even when the form value is reset to
            // undefined/null (e.g. "Reset to source" reverting to an empty
            // source value). Without this, React falls back to uncontrolled and
            // leaves the last typed value stranded in the DOM.
            value={field.value ?? ''}
            sx={{ width: '100%', ...sx }}
            error={(!!errors && !!errors[id]?.message) || !!error}
            id={id}
            type={type}
            label={label}
            placeholder={placeholder}
            autoFocus={autoFocus}
            required={required}
            variant="standard"
            InputLabelProps={{ ...inputLabelProps }}
            multiline={multiline}
            helperText={(!!errors && errors[id]?.message) || error}
            InputProps={{ ...inputProps }}
            disabled={disabled}
            inputProps={{ ...inputAttributes }}
            onChange={onChange ? onChange : field.onChange}
          />
        );
      }}
    />
  );
};
